import { extendTheme } from "@chakra-ui/react";

const customTheme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false, 
  },
  styles: {
    global: {
      body: {
        // bg: "#F5F5DC",
        // color: "gray.800",
      },
    },
  },
});

export default customTheme;